import I18n from 'I18n';
export function getIsCurrentTrial(state, trialId) {
  const {
    activeTrials
  } = state;
  const isCurrentTrial = activeTrials.some(activeTrial => {
    return activeTrial.trials[0].id === trialId;
  });
  return isCurrentTrial;
}
export function getDaysLeftInTrial(state, trialId) {
  const {
    activeTrials
  } = state;
  const trial = activeTrials.find(activeTrial => {
    return activeTrial.trials[0].id === trialId;
  });
  if (!trial) {
    return 0;
  }
  const endsAtTimestamp = trial.endsAt;
  const hoursRemaining = I18n.moment(endsAtTimestamp).diff(I18n.moment(), 'hours');
  return hoursRemaining < 24 && hoursRemaining > 0 ? 1 : I18n.moment(endsAtTimestamp).diff(I18n.moment(), 'days');
}